import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { UploadResponse } from '@interfaces/common.model';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { GlobalErrorService } from './global-error.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private fileUploadUrl = environment.fileUploadApiUrl;
  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  uploadFile(file: File, folderName: string): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folderName', folderName);

    return this.http
      .post<UploadResponse>(`${this.fileUploadUrl}/files/upload`, formData)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }
}
